import { render, staticRenderFns } from "./PopUpCoupon.vue?vue&type=template&id=32f55114&scoped=true&"
import script from "./PopUpCoupon.vue?vue&type=script&lang=js&"
export * from "./PopUpCoupon.vue?vue&type=script&lang=js&"
import style0 from "./PopUpCoupon.vue?vue&type=style&index=0&id=32f55114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f55114",
  null
  
)

export default component.exports